/** @format */

import React from "react";

function Posts({ newslettersData, handleClick }) {
  return (
    <section className="case-study-post-archive">
      <div className="container">
        <div className="row">
          {newslettersData
            .map(
              (data) =>
                data?.type === "case study" && (
                  <div className="case-study-post-grid" key={data.url}>
                    {/* <a
                      href={data.url}
                      target={data.sameTab ? "_self" : "_blank"}
                      rel="noopener noreferrer"
                    > */}
                    <div
                      onClick={() => {
                        handleClick(`${data.url}`);
                      }}
                    >
                      <article className="case-study-grid">
                        <div className="feature-image">
                          <img
                            alt={data.title}
                            src={
                              !new Set(["svg", "webp"]).has(
                                data.image.split(".")[1]
                              )
                                ? require(`../../../../assets/${data.image}`)
                                    .default
                                : require(`../../../../assets/${data.image}`)
                            }
                          />
                        </div>
                        <div className="case-study-content">
                          <div className="case-study-title">{data.title}</div>
                          <div className="case-study-description">
                            {data.content}
                          </div>
                          <div className="case-study-badge-cover">
                            <div className="case-study-badge">{data.type}</div>
                            <div className="case-study-status">
                              {data.status}
                            </div>
                          </div>
                        </div>
                      </article>
                    </div>
                    {/* </a> */}
                  </div>
                )
            )
            .reverse()}
        </div>
      </div>
    </section>
  );
}

export default Posts;
